import { useEffect, useState } from 'react'
import QRCode from 'qrcode'

/** The link attendees reach from the QR code. Built from this site's own address so it works in every environment. */
export const signInUrl = (code: string) => `${window.location.origin}/signin/${code}`

/** A QR code for a link, drawn at twice the size it is shown so it stays sharp. */
export function Qr({ url, size }: { url: string; size: number }) {
  const [src, setSrc] = useState<string | null>(null)
  useEffect(() => {
    let alive = true
    QRCode.toDataURL(url, { margin: 1, width: size * 2, errorCorrectionLevel: 'M' }).then(d => { if (alive) setSrc(d) }).catch(() => undefined)
    return () => { alive = false }
  }, [url, size])
  return src
    ? <img src={src} alt="QR code to sign in" width={size} height={size} className="rounded bg-white" />
    : <div style={{ width: size, height: size }} className="rounded bg-gray-100" />
}
